import { render, staticRenderFns } from "./ManterAcompanhamentoDeTurmas.vue?vue&type=template&id=30cf133f"
import script from "./ManterAcompanhamentoDeTurmas.vue?vue&type=script&lang=js"
export * from "./ManterAcompanhamentoDeTurmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports